import { Box, Container, Stack, Tab, Tabs } from '@mui/material';
import { AuthStatus, useAuth } from '../auth/Auth';
import { useState } from 'react';
import SocialBar from '../socials/SocialBar';
import LoadingPage from '../loading/LoadingPage';
import { TabContext, TabPanel } from '@mui/lab';
import VideoTab from './VideoTab';

export enum MediaType {
    Video = 'Video',
    Short = 'Short',
}

const VideosPage = () => {
    const auth = useAuth();
    const [value, setValue] = useState('Video');

    if (auth.status === AuthStatus.Loading) {
        return <LoadingPage />;
    }

    return (
        <Container maxWidth='lg' sx={{ pt: 4, mb: '100px' }}>
            <Stack spacing={4}>
                <TabContext value={value}>
                    <Box
                        sx={{
                            width: '100%',
                            typography: 'body1',
                            mt: 5,
                            justifyContent: 'center',
                            display: 'flex',
                        }}
                    >
                        <Tabs
                            value={value}
                            onChange={(_, t) => setValue(t)}
                            textColor='inherit'
                            variant='scrollable'
                        >
                            <Tab label='Videos' value='Video' />
                            <Tab label='Shorts' value='Short' />
                        </Tabs>
                    </Box>
                    <TabPanel value='Video'>
                        <VideoTab mediaType={value} />
                    </TabPanel>
                    <TabPanel value='Short'>
                        <VideoTab mediaType={value} />
                    </TabPanel>
                </TabContext>
            </Stack>
            <SocialBar />
        </Container>
    );
};

export default VideosPage;
